import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

export const RedirectResetPassword = (): JSX.Element => {
  const { t } = useTranslation();
  const redirectExecuted = useRef(false);

  useEffect(() => {
    if (redirectExecuted.current) {
      return;
    }

    redirectExecuted.current = true;

    const realmUrl = process.env.REACT_APP_KEYCLOAK_REALM_URL;
    const clientId = process.env.REACT_APP_KEYCLOAK_CLIENT_ID;
    const redirectUri = process.env.REACT_APP_KEYCLOAK_REDIRECT_URI;

    if (!realmUrl || !clientId || !redirectUri) {
      console.error('RedirectResetPassword: missing REACT_APP_KEYCLOAK_* environment variables');
      return;
    }

    const url = `${realmUrl}/login-actions/reset-credentials`
      + `?client_id=${clientId}`
      + `&redirect_uri=${encodeURIComponent(redirectUri)}`;

    window.location.href = url;
  }, []);

  return (
    <div>
      <h1 style={{ fontSize: 16, paddingTop: 20 }}>{t('redirecionando')}</h1>
    </div>
  );
};
